import axios from 'axios';

//axios.defaults.baseURL = "https://localhost:44305/api/";
//axios.defaults.baseURL = "https://dev.taco.co.il/clalit-api/api/"; // <<== "prod"

//axios.defaults.baseURL = 'https://localhost:44352/api/';
axios.defaults.baseURL = 'https://dev.taco.co.il/kapi/api/'; // <<== "prod"
